import { Injectable } from '@angular/core';
import { LogDisplayDto } from '../../admin/import/log.diplay.dto';
import { environment } from '../../environments/environment';
import { FileDataDto } from '../file-input/file-data.dto';
import { ApiService } from './api.service';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  constructor(
    private readonly apiService: ApiService,
    private readonly fileService: FileService,
  ) {}

  public async importCsv(fileDataDto: FileDataDto): Promise<string> {
    return this.apiService.postString<FileDataDto>(environment.api.import + '/beneficiaries/csv', fileDataDto);
  }

  public async getIodasLogsList(): Promise<LogDisplayDto[]> {
    return this.apiService.get<LogDisplayDto[]>(environment.api.import + '/iodas-logs');
  }

  public async getCsvLogsList(): Promise<LogDisplayDto[]> {
    return this.apiService.get<LogDisplayDto[]>(environment.api.import + '/csv-logs');
  }

  public async downloadLog(id: number, fileName: string): Promise<void> {
    const data: Blob = await this.apiService.getFile(environment.api.import + '/' + id + '/download');
    return this.fileService.saveAs(data, fileName);
  }
}
